<!--testimonial section start-->
<section class="event testimonial set-relative bg bg-img bg-about"  [ngStyle]="{'background-image': 'url(assets/images/event/bg1.jpg)'}">
    <div class="container">
        <div class="row">
            <div class="col-md-10 offset-md-1">
                <div class="title title3">
                    <div class="main-title">
                        <h2 class=" text-white">Kundenmeinungen</h2>
                    </div>
                    <div class="sub-title">
                        <p class="text-white">
                            Lesen Sie, was unsere zufriedenen Kunden über ihre Erfahrungen mit uns sagen. Echte Bewertungen, die Ihnen helfen, die richtige Entscheidung zu treffen!
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-10 offset-md-1 margin-b">
                <owl-carousel-o [options]="testimonialcarouselOptions" class="testimonial">
                    @for(data of testimonial; track data){
                        <ng-template carouselSlide class="item">
                            <div class="col-lg-10 offset-lg-1 col-12  p-t-30">
                                <div class="row">
                                    <div class="col-sm-3">
                                        <div class="testimonial-msg set-relative">
                                            <img [src]="data.img" alt="" class="img-fluid">
                                            <div class="msg-box">
                                                <div class="center-content">
                                                    <img [src]="data.msgIcon"
                                                         alt=""
                                                         class="img-fluid set-abs">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-9">
                                        <div class="quote-margin">
                                            <div class="quotes set-relative m-b-30">
                                                <img src="assets/images/event/testimonial/i1.png" alt=""
                                                     class="img-fluid set-abs left-quote">
                                                <div class="quote-text">
                                                    <h6 class="text-white">{{data.testimonial}}</h6>
                                                </div>
                                                <img src="assets/images/event/testimonial/i2.png" alt=""
                                                     class="img-fluid set-abs right-quote">
                                            </div>
                                            <div class="rating align-items-center">
                                                <div class="stars">
                                                    <ul>
                                                        <li *ngFor="let star of getStars(data.rating)">
                                                            <i class="fa fa-star" [ngClass]="star" aria-hidden="true"></i>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <h5 class="name">{{ data.name }} - <span>{{ data.designation }}</span></h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    }

                </owl-carousel-o>
            </div>
        </div>
    </div>
</section>
<!--testimonial section end-->
